<div class="add-button-container" tid="section-add">
    <div class="icon-plus">
        <kendo-dropdownlist (selectionChange)="onFieldClick($event)" [popupSettings]="{appendTo: 'root'}"
            [data]="fieldCandidates" [textField]="'label'" [valueField]="'controlId'" [defaultItem]="defaultEmptyItem">
        </kendo-dropdownlist>
    </div>
</div>
